export const iconFontAwesomeFruitsVegetablesLeaf = (
	<i className="fa-solid fa-leaf"></i>
);
